import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch, Redirect, withRouter } from 'react-router-dom'
import Alert from 'react-s-alert'
import flow from 'lodash/flow'
import { connect } from 'react-redux'
import { getUser } from '../selectors'
import { login } from '../state/user'
import { Login, Logout }  from './auth'
import { ModalAlert } from './widgets'
import { protect, agent } from '../lib'
import MainNav from './nav/MainNav'
import Sidebar from './nav/Sidebar'
//import '../css/bootstrap.min.css'
//import '../css/bootstrap-theme.min.css'
import 'typeface-roboto'
import 'bootstrap/dist/css/bootstrap.css'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/scale.css'
import '../css/pixeladmin.css'
import '../css/widgets.css'
import '../css/asphalt.css'
import '../css/react-bootstrap-table.css'
import '../css/alert.css'
import '../css/dygraphs.css'
import '../css/app.css'

import apps from './sm'
//import apps from './station'

const actionsToProps = dispatch => ({
  login: user => dispatch(login(user))
})

const stateToProps = state => ({
  user: getUser(state),
})

class App extends React.Component {

  notSupported = () => {
    return (
      <ModalAlert type='danger'
        title={'Sorry, your browser is not supported'}
        content={agent.name() + ' ' + agent.version()}
        onClose={agent.upgrade}
      />
    )
  }

  route = () => {
    let arr = []
    for (let key in apps) {
      arr = arr.concat(apps[key])
    }

    return arr.reduce((route, app, idx) => {
      if ('component' in app) {
        const Component = protect(app.component)
        route.push(
          <Route exact key={idx} path={app.alias}
            render={ props => <Component {...this.props} {...props} icon={app.icon} title={app.name} param={app.param || ''} /> }
          />
        )
      }
      return route
    }, [])
  }

  render() {
    if (!agent.support()) return this.notSupported()

    return (
      <div>
        <Sidebar {...this.props} apps={apps}/>
        <MainNav {...this.props} apps={apps}/>
        <div className='px-content'>
          <Switch>
            { this.route() }
            <Route path='/login' component={Login} />
            <Route path='/logout' component={Logout} />
            <Redirect to='/' />
          </Switch>
        </div>
        <Alert stack={{limit: 3, spacing: 10}} effect='scale' position='top-right' offset={64} timeout={5000}/>
      </div>
    )
  }
}

App.propTypes = {
    user: PropTypes.object,
    login: PropTypes.func
}

const decorators = flow([
    connect(stateToProps, actionsToProps),
    withRouter
])

export default decorators(App)



// WEBPACK FOOTER //
// ./src/components/App.js